export function OctopusLogo({ className }) {
  return (
    <div className={className}>
      <svg
        width="48"
        height="48"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="octopus-title"
        role="img"
      >
        <title id="octopus-title">The Octopus logo</title>
        <rect width="100%" height="100%" fill="#E6F3FA" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.3773 36.5447C43.5182 33.9175 45.5304 29.8735 45.5304 25.3374C45.5304 17.4191 39.3987 11 31.8349 11C24.271 11 18.1393 17.4191 18.1393 25.3374C18.1393 29.761 20.0529 33.7166 23.0608 36.3466C22.4877 37.0933 21.7774 37.899 20.961 38.6395C19.3862 40.0681 17.6458 41.0493 15.9208 41.1919C14.6645 41.2957 13.7309 42.3899 13.8356 43.6359C13.9403 44.8818 15.0436 45.8077 16.2999 45.7038C18.9865 45.4818 21.3163 44.2072 23.1491 42.7419C22.499 43.7889 21.8675 44.7608 21.302 45.5643C20.6255 46.5254 20.1552 47.0822 19.9199 47.2896C18.9777 48.1202 18.8928 49.5511 19.7303 50.4856C20.5679 51.42 22.0106 51.5042 22.9529 50.6736C23.6306 50.0761 24.3671 49.1195 25.0454 48.1559C25.7606 47.1398 26.5393 45.9278 27.3043 44.682C27.9866 43.571 28.6686 42.4158 29.2986 41.322V49.7362C29.2986 50.9865 30.3206 52 31.5812 52C32.8419 52 33.8638 50.9865 33.8638 49.7362V41.1977C34.5582 42.5101 35.3263 43.8995 36.0965 45.1913C36.8678 46.4849 37.6709 47.7308 38.4262 48.7147C38.8024 49.2049 39.2008 49.6749 39.6079 50.0649C39.9692 50.4112 40.5342 50.89 41.2579 51.1292C42.4539 51.5246 43.7465 50.8836 44.1452 49.6975C44.523 48.5733 43.9621 47.3629 42.8842 46.903C42.8599 46.8827 42.8252 46.8522 42.7799 46.8088C42.6018 46.6381 42.3598 46.3646 42.0586 45.9722C41.4591 45.1913 40.7595 44.1168 40.026 42.8866C39.9845 42.817 39.943 42.747 39.9014 42.6768C41.6011 43.9958 43.7571 45.0169 46.3823 45.2028C47.6397 45.2919 48.7319 44.3532 48.8217 43.1061C48.9115 41.859 47.965 40.7758 46.7075 40.6867C44.5977 40.5373 42.9044 39.4849 41.5844 38.0768C41.1215 37.583 40.7193 37.06 40.3773 36.5447Z"
          fill="#91CDE8"
        />
        <path
          d="M46.8965 34.2755C47.9648 33.5875 49.3851 33.9012 50.0688 34.9763C50.7524 36.0514 50.4407 37.4807 49.3724 38.1687C47.9767 39.0677 46.6186 39.6197 45.3276 39.9106C43.2863 39.5745 41.7553 37.3972 41.2449 36.7357L42.5208 35.5192C43.7822 35.6126 45.2733 35.321 46.8965 34.2755Z"
          fill="#91CDE8"
        />
        <path
          d="M13.3276 34.8718C13.9802 33.7773 15.3908 33.4224 16.4784 34.0791C18.0963 35.056 19.759 35.4232 21.2781 35.4476L22.1864 36.3177C21.6224 37.1494 19.8632 38.9999 18.3589 39.748C16.9665 39.4414 15.5349 38.8999 14.1153 38.0427C13.0277 37.386 12.6751 35.9663 13.3276 34.8718Z"
          fill="#91CDE8"
        />
        <path
          d="M37.8276 28.5C37.8276 29.3284 37.156 30 36.3276 30C35.4992 30 34.8276 29.3284 34.8276 28.5C34.8276 27.6716 35.4992 27 36.3276 27C37.156 27 37.8276 27.6716 37.8276 28.5Z"
          fill="#001657"
        />
        <path
          d="M27.8276 28.5C27.8276 29.3284 27.156 30 26.3276 30C25.4992 30 24.8276 29.3284 24.8276 28.5C24.8276 27.6716 25.4992 27 26.3276 27C27.156 27 27.8276 27.6716 27.8276 28.5Z"
          fill="#001657"
        />
      </svg>
    </div>
  );
}

export default OctopusLogo;
